export class ProfileCommon {
  public static employeeFormErrors = {
  'firstName': '',
  'middleName': '',
  'lastName': '',
  'password': '',
  'dateOfBirth':'',
  'bloodGroup': '',
  'panNumber': '',
  'aadharNumber': '',
  'qualification': '',
  'userQualifications': '',
  'certificationType': '',
  'serviceVerticle': '',
  'exitDate':'',
  'description':'',
  'gender':'',
  'profileStatus': '',
  'loginAccess': '',
  'email':'',
  'personalEmail':'',
  'officalMobileNumber':'',
  'contactMobileNumber':'',
  'landlineStdCode':'',
  'landlineNumber':'',
  'emergencyContactNumber1':'',
  'emergencyContactName1':'',
  'emergencyContactRelation1':'',
  'emergencyContactNumber2':'',
  'emergencyContactName2':'',
  'emergencyContactRelation2':'',
  'address':'',
  'city':'',
  'state':'',
  'postalCode':'',
  'country':'',
  'streetName':'',

  'branch':'',
  'droles':'',
  'designation':'',
  'reportingManager':'',
  'reportingPartner':'',
  'joiningDate':'',
  'membershipNumber':'',
  'dateOfMembershipNumber':'',
  'probabtionPeriod':'',
  'articleTrainingLimit':'',
  'verified':'',
  'confirmationDate':'',
  'commitmentDate':'',
  'verificationSource':'',
  'remark':'',
  'laptopServiceTagNumber':'',
  'dataCardNumber':'',
  'bankAcountName':'',
  'bankAccountNumber':'',
  'bankIfscCode':'',
  'icaiRegistrationDate':'',
  'icaiRegistrationNumber':'',
  'articleshipEndDate':'',
  'registeredPartner':'',
  'articleType':'',
  'clients':'',
  'startDate':'',
  'endDate':'',
  'scholarship' : '',
  'userCtcDetails' : '',
  // 'basic':'',
  // 'hra':'',
  // // mobileAllowance:'',
  // 'otherAllowance':'',
  // 'conveyanceAllowance':'',
  // 'medicalAllowance':'',
  // 'educationAllowance':'',
  // 'childHostelAllowance':'',
  // 'fromDate':'',
  // 'toDate':'',
  };

  public static employeeFormValidationMessages = {
  'firstName': {
  'required': 'first name is required.',
  'minlength': 'first name is minlength 50.',
  'maxlength': 'first name is maxlength 50',
  },
  'middleName': {
  'required': 'middle name is required.',
  'minlength': 'middle name is minlength 50.',
  'maxlength': 'middle name is maxlength 50',
  },
  'lastName': {
  'required': 'last name is required.',
  'minlength': 'last name is minlength 50.',
  'maxlength': 'last name is maxlength 50',
  },
  "password":{ 'required': 'mandatory field'},
  'dateOfBirth': {
  'required': 'date of birth is required.',
  'ngbDate':''
  },
  'bloodGroup': {
    'required': 'blood group is required.'
  },
  'panNumber': {
    'required': 'pan number is required.',
    'pattern': 'invalid pan'
  },
  'aadharNumber': {
    'required': 'aadhar number is required.',
    'pattern': 'invalid aadhar'
  },
  'qualification': { 'required': 'qualification is required.'},
  'userQualifications': { 'required': 'userQualifications is required.'},
  'certificationType': { 'required': 'certification is required.'},
  'serviceVerticle': { 'required': 'service vertical is required.'},
  'exitDate': { 'required': 'exit date is required.'},
  'description': { 'required': 'description is required.'},
  'gender': { 'required': 'gender is required.'},
  'profileStatus': { 'required': 'profile status is required.'},
  'loginAccess': { 'required': 'login access is required.'},
  'email': { 'required': 'official email is required.', 'email' : "invalid email format"},
  'personalEmail': { 'required': 'personal email is required.'},
  'officalMobileNumber':{ 'required': 'official mobile no is required.'},
  'contactMobileNumber': { 'required': 'personal mobile no is required.'},
  'landlineStdCode':{ 'required': 'std code is required.'},
  'landlineNumber': { 'required': 'landline no is required.'},
  'emergencyContactNumber1':{ 'required': 'emergency contact no is required.'},
  'emergencyContactName1':{ 'required': 'emergency contact name is required.'},
  'emergencyContactRelation1': { 'required': 'emergency contact realtion is required.'},
  'emergencyContactNumber2': {'required': 'emergency contact no is required.'},
  'emergencyContactName2': {'required': 'emergency contact name is required.'},
  'emergencyContactRelation2': { 'required': 'emergency contact realtion is required.'},
  'address': { 'required': 'address is required.'},
  'city':{ 'required': 'city is required.'},
  'state':{ 'required': 'state is required.'},
  'postalCode':{ 'required': 'pincode is required.'},
  'country':{ 'required': 'country is required.'},
  'streetName':{ 'required': 'mandatory field.'},

  'branch':{ 'required': 'mandatory field'},
  'droles':{ 'required': 'mandatory field'},
  'designation':{ 'required': 'mandatory field'},
  'reportingManager':{ 'required': 'mandatory field'},
  'reportingPartner':{ 'required': 'mandatory field'},
  'joiningDate':{ 'required': 'mandatory field'},
  'membershipNumber':{ 'required': 'mandatory field'},
  'dateOfMembershipNumber':{ 'required': 'mandatory field'},
  'probabtionPeriod':{ 'required': 'mandatory field'},
  'articleTrainingLimit':{ 'required': 'mandatory field'},
  'verified':{ 'required': 'mandatory field'},
  'confirmationDate':{ 'required': 'mandatory field'},
  'commitmentDate':{ 'required': 'mandatory field'},
  'verificationSource':{ 'required': 'mandatory field'},
  'remark':{ 'required': 'mandatory field'},
  'laptopServiceTagNumber':{ 'required': 'mandatory field'},
  'dataCardNumber':{ 'required': 'mandatory field'},
  'bankAcountName':{ 'required': 'mandatory field'},
  'bankAccountNumber':{ 'required': 'mandatory field'},
  'bankIfscCode':{ 'required': 'mandatory field'},
  'icaiRegistrationDate':{ 'required': 'mandatory field'},
  'icaiRegistrationNumber':{ 'required': 'mandatory field'},
  'articleshipEndDate':{ 'required': 'mandatory field'},
  'registeredPartner':{ 'required': 'mandatory field'},
  'articleType':{ 'required': 'mandatory field'},
  'clients':{ 'required': 'mandatory field'},
  'startDate':{ 'required': 'mandatory field'},
  'endDate':{ 'required': 'mandatory field'},
  'userCtcDetails':{'required': 'CTC is mandatory field'},
  // 'basic':{ 'required': 'mandatory field'},
  // 'hra':{ 'required': 'mandatory field'},
  // // mobileAllowance:'',
  // 'otherAllowance':{ 'required': 'mandatory field'},
  // 'conveyanceAllowance':{ 'required': 'mandatory field'},
  // 'medicalAllowance':{ 'required': 'mandatory field'},
  // 'educationAllowance':{ 'required': 'mandatory field'},
  // 'childHostelAllowance':{ 'required': 'mandatory field'},
  // 'fromDate':{ 'required': 'mandatory field'},
  // 'toDate':{ 'required': 'mandatory field'},

  };

  public static employeeCtcFormErrors = {
    'ctc': '',
     'basic': '',
     'childHostelAllowance': '',
     'variableComponentPercent': '',
     'variableComponent': '',
     'conveyanceAllowance': '',
     'educationAllowance': '',
     'esic': '',
     'exgratia': '',
    // 'exgratiaMonth': '',
    'uanNo': '',
     'fromDate': '',
     'hra': '',
     'medicalAllowance': '',
    //  'mobileAllowance': '',
     'professionalExceptionMonth': '',
     'professionalExceptionTax': '',
     'professionalTax': '',
     'providentFund': '',
    // 'securityDeposit': '',
    // 'securityFromDate': '',
     'securityToDate': '',
     'toDate': '',
     'designation': '',
      'overtimeApplicability': '',
     'laptopEligibility': '',
     'epfApplicable': '',
     'tds':'',
    //  'loanFromDate':'',
    //  'loanToDate':'',
     'loan':'',
     'emi':'',
     'recoveryOrExpenses':'',
  }

  public static employeeCtcFormValidationMessages = {
    'basic': { 'required': 'mandatory field'},
    'childHostelAllowance': { 'required': 'mandatory field'},
    'variableComponent': { 'required': 'mandatory field'},
    'conveyanceAllowance': { 'required': 'mandatory field'},
    'educationAllowance': { 'required': 'mandatory field'},
    'exgratia': { 'required': 'mandatory field'},
    // 'exgratiaMonth': { 'required': 'mandatory field'},
    'fromDate': { 'required': 'mandatory field'},
    'hra': { 'required': 'mandatory field'},
    'medicalAllowance': { 'required': 'mandatory field'},
    // 'mobileAllowance': { 'required': 'mandatory field'},
    'professionalExceptionMonth': { 'required': 'mandatory field'},
    'professionalExceptionTax': { 'required': 'mandatory field'},
    'professionalTax': { 'required': 'mandatory field'},
    'providentFund': { 'required': 'mandatory field'},
    'securityDeposit': { 'required': 'mandatory field'},
    // 'securityFromDate': { 'required': 'mandatory field'},
    // 'securityToDate': { 'required': 'mandatory field'},
    'toDate': { 'required': 'mandatory field'},
    'designation':{ 'required': 'mandatory field'},
    'overtimeApplicability':{ 'required': 'mandatory field'},
    'tds':{ 'required': 'mandatory field'},
    'esic':{ 'required': 'mandatory field'},
    'laptopEligibility':{ 'required': 'mandatory field'},
    'epfApplicable':{ 'required': 'mandatory field'},
    'emi':{ 'required': 'mandatory field'},
    'loan':{ 'required': 'mandatory field'},
    // 'loanFromDate':{ 'required': 'mandatory field'},
    // 'loanToDate':{ 'required': 'mandatory field'},
    'recoveryOrExpenses':{ 'required': 'mandatory field'},
  }


  public static articleDocuments = {
    'personalDocumentList':[
      {'name':'Resume','required':true,"type":"file","label":"Resume","url":""},
      {'name':'ArticleQuestionnaire','required':true,"type":"file","label":"Article Questionnaire","url":""},
      {'name':'10thMarksheet','required':true,"type":"file","label":"10th Marksheet","url":""},
      {'name':'12thMarksheet','required':true,"type":"file","label":"12th Marksheet","url":""},
      {'name':'IPCCMarksheet','required':true,"type":"file","label":"IPCC Marksheet","url":""},
      {'name':'OrientationCertificate','required':false,"type":"file","label":"Orientation Certificate","url":""},
      {'name':'ITTCertificate','required':false,"type":"file","label":"ITT Certificate","url":""},
      {'name':'GraduationMarksheet','required':false,"type":"file","label":"Graduation Marksheet","url":""},
      {'name':'AadharCard','required':false,"type":"file","label":"Aadhar Card","url":""},
      {'name':'PANCard','required':false,"type":"file","label":"PAN Card","url":""},
      {'name':'PassportPhoto','required':true,"type":"file","label":"Passport Photo","url":""},
      {'name':'OtherDocuments','required':false,"type":"file","label":"Other Documents","url":""},
    ],
    'officialDocumentList':[
      {'name':'NonDisclosureAgreement','required':false,"type":"file","label":"Non Disclosure Agreement","url":""},
      {'name':'CommitmentLetter','required':true,"type":"file","label":"Commitment Letter","url":""},
    ],
  }

  public static tempArticleDocuments = {
    'personalDocumentList':[
      {'name':'Resume','required':false,"type":"file","label":"Resume","url":""},
      {'name':'AadharCard','required':false,"type":"file","label":"Aadhar Card","url":""},
      {'name':'PANCard','required':false,"type":"file","label":"PAN Card","url":""},
      {'name':'PassportPhoto','required':true,"type":"file","label":"Passport Photo","url":""},
    ],
    'officialDocumentList':[
      {'name':'NonDisclosureAgreement','required':false,"type":"file","label":"Non Disclosure Agreement","url":""},
    ],
  }

  public static employeeDocuments = {
    'personalDocumentList':[
      {'name':'Resume','required':true,"type":"file","label":"Resume","url":""},
      {'name':'EmployeeQuestionnaire','required':true,"type":"file","label":"Employee Questionnaire","url":""},
      {'name':'GraduationMarksheet','required':true,"type":"file","label":"Graduation Marksheet","url":""},
      {'name':'CAMarksheet','required':false,"type":"file","label":"CA Marksheet","url":""},
      {'name':'MembershipCertificateOrMemberCard','required':false,"type":"file","label":"Membership Certificate Or Member Card","url":""},
      {'name':'AadharCard','required':true,"type":"file","label":"Aadhar Card","url":""},
      {'name':'PANCard','required':true,"type":"file","label":"PAN Card","url":""},
      {'name':'PassportPhoto','required':true,"type":"file","label":"Passport Photo","url":""},
      {'name':'SalaryslipFromPreviousEmployer','required':false,"type":"file","label":"Salary slip from Previous Employer","url":""},
      {'name':'RelievingOrExperienceLetterFromPreviousEmployer','required':false,"type":"file","label":"Relieving Or Experience Letter from Previous Employer","url":""},
      {'name':'AppointmentLetterFromPreviousEmployer','required':false,"type":"file","label":"Appointment Letter from Previous Employer","url":""},
      {'name':'OtherDocuments','required':false,"type":"file","label":"Other Documents","url":""},
    ],
    'officialDocumentList':[
      {'name':'NonDisclosureAgreement','required':false,"type":"file","label":"Non Disclosure Agreement","url":""},
      {'name':'AppointmentLetter','required':false,"type":"file","label":"Appointment Letter","url":""},
    ],
  };

  public static consultantDocuments = {
    'personalDocumentList':[
      {'name':'Resume','required':true,"type":"file","label":"Resume","url":""},
      {'name':'AadharCard','required':true,"type":"file","label":"Aadhar Card","url":""},
      {'name':'PANCard','required':true,"type":"file","label":"PAN Card","url":""},
      {'name':'OtherDocuments','required':false,"type":"file","label":"Other Documents","url":""},
    ],
    'officialDocumentList':[
      {'name':'NonDisclosureAgreement','required':false,"type":"file","label":"Non Disclosure Agreement","url":""},
      {'name':'ConsultantAgreement','required':false,"type":"file","label":"Consultant Agreement","url":""},
      // {'name':'OtherDocuments','required':false,"type":"file","label":"Other Documents","url":""},
    ],
  }





  }


